<template>
    <div>
        <Modal class-name="vertical-center-modal" :value="showModel" :title="title" :footer-hide="true"
            :mask-closable="false" @on-cancel="cancel" @on-visible-whetherSync="openOrClose"
            :styles="{ 'min-width': '960px' }">


            <Upload type="drag" :before-upload="handleBeforeUpload" accept=".xls, .xlsx" action="">
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>Click file here to upload</p>
                </div>
            </Upload>

            <div v-show="tableData.length">
                <Table style="width: 100%;margin-top: 30px;" id="mytable" width="960" height="200" :columns="tableTitle"
                    :data="tableData" :loading='tableLoading' ></Table>

                <div style="text-align:center;margin-top: 10px;">
                    <Checkbox v-model="whetherSync">{{ $t('productPage.mulLang.whetherSync') }}</Checkbox>
                    <div v-show="!allowUpload">
                        <div>提示1:红色可能为wordCode存在重复项或者输入格式有误，只有格式全部正确才可以上传</div>
                        <div>提示2:wordCode为数字、字母或者下划线组成的字符串。其他不可以为空，可以输入一个空格</div>
                    </div>
                </div>
            </div>

            <div style="text-align:center;color:#ed4014">
                <div v-show="disabled">{{ $t("productPage.mulLang.creating") }}</div>
                <div v-show="disabled || finish">
                    {{ $t("productPage.mulLang.total") }}{{ tableData.length }},{{ $t("productPage.mulLang.valid") }}{{
                        totalCount }},{{ $t("productPage.mulLang.success") }}{{ successCount }},{{$t("productPage.mulLang.fail") }}{{ failCount }}
                </div>
            </div>


            <div class="flexCC" style="margin-top: 30px;">
                <Button :loading="disabled" :disabled="!tableData.length || !allowUpload" type="primary"
                    @click="modalTip = true" style="margin-right:20px">{{ $t('productPage.mulLang.addTitle') }}</Button>
                <Button :disabled="disabled" @click="cancel">{{ $t('cancel') }}</Button>
                <!-- <Button :disabled="disabled" @click="savetoexcel">{{$t('cancel')}}</Button> -->
            </div>

            <Modal class-name="vertical-center-modal" v-model="modalTip" title="Tip 提示" @on-cancel="modalTip = false"
                @on-ok="subData" :ok-text="$t('confirm')" :cancel-text="$t('cancel')" width="300">
                <p>{{ $t("productPage.mulLang.tipContent") }}</p>
            </Modal>

        </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import * as XLSX from 'xlsx/xlsx.mjs';
import common from '@/common/common';
import excel from '@/common/excel'
import { mapState } from 'vuex'

export default {
    props: {
        showModel: Boolean,
        fn: Function,
        pageId: Number
    },
    name: "ModelImport",
    components: {
    },
    data() {
        return {
            disabled: false,//禁用确定按钮
            title: '',//弹框标题
            content: "",
            file: {},
            tableData: [],
            jsonData: [],
            tableTitle: [],
            uploadLoading: false,
            tableLoading: false,
            showRemoveFile: false,
            showProgress: false,
            progressPercent: 0,
            whetherSync: true,
            modalTip: false,
            totalCount: 0,
            successCount: 0,
            failCount: 0,
            finish: false,
            allowUpload: true
        }
    },

    computed: {
        ...mapState(['selectId', 'showChildrenSide']),

    },
    created() {
    },
    mounted() {
    },
    watch: {
        showModel(val) {
            if (val == true) {

                this.title = this.$t("productPage.mulLang.importTip")
            } else {
                this.resetForm();//重置表单
            }

        },
    },
    methods: {
        savetoexcel() {
            // 需要导出的数据
            // const exportArr = this.tableData
            const exportArr = [
                {
                    "wordCode": "level14",
                    "simpleChinese": "",
                    "traditionalChinese": "level14",
                    "englishText": "level14",
                    "frenchText": "level14",
                    "germanText": "level14",
                    "spanishText": "level14",
                    "japanText": "level14",
                    // "addFlag": false
                },
                {
                    "wordCode": "level15",
                    "simpleChinese": "等级15",
                    "traditionalChinese": "",
                    "englishText": "level15",
                    "frenchText": "level15",
                    "germanText": "level15",
                    "spanishText": "level15",
                    "japanText": "level15",
                    // "addFlag": false
                }
            ]

            // 自定义下载的header，注意是数组中的数组哦

            let arr = []
            this.tableTitle.map((item) => {
                arr.push(item.title)
            })
            const Header = [["wordCode", "simpleChinese", "traditionalChinese", "englishText", "frenchText", "germanText", "spanishText", "japanText"]];

            // console.log('Header',Header)
            // console.log('exportArr',exportArr)

            // 将JS数据数组转换为工作表。
            const headerWs = XLSX.utils.aoa_to_sheet(Header);
            const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, { skipHeader: true, origin: 'A2' });

            /* 新建空的工作表 */
            const wb = XLSX.utils.book_new();

            // 可以自定义下载之后的sheetname
            XLSX.utils.book_append_sheet(wb, ws, 'sheetName');

            /* 生成xlsx文件 */
            XLSX.writeFile(wb, '下载.xlsx');
        },
        handleBeforeUpload(file) {
            const fileExt = file.name.split('.').pop().toLocaleLowerCase()
            if (fileExt === 'xlsx' || fileExt === 'xls') {
                this.readFile(file)

                this.file = file
            } else {
                this.$Notice.warning({
                    title: '文件类型错误',
                    desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
                })
            }
            return false
        },
        readFile(file) {
            const reader = new FileReader()
            reader.readAsArrayBuffer(file)
            reader.onloadstart = e => {
                this.uploadLoading = true
                this.tableLoading = true
                this.showProgress = true
            }
            reader.onprogress = e => {
                this.progressPercent = Math.round(e.loaded / e.total * 100)
            }
            reader.onerror = e => {
                this.$Message.error(this.$t("productPage.mulLang.readF"))
            }
            reader.onload = e => {
                this.$Message.info(this.$t("productPage.mulLang.readS"))
                const data = e.target.result
                const {
                    header,
                    results
                } = excel.read(data, 'array')

                let filedArr = ["wordCode", "simpleChinese", "traditionalChinese", "englishText", "frenchText", "germanText", "spanishText", "japanText"]


                // 判断wordCode是否重复
                let wordCodes = results.map(value => value.wordCode);
                let wordCodesSet = [...new Set(wordCodes)];
                let repeatCode = []
                if (wordCodesSet.length != wordCodes.length) {
                    var _obj = {};
                    // var str = wordCodes.join()
                    for (var i = 0; i < wordCodes.length; i++) {//遍历字符串
                        if (_obj[wordCodes[i]]) {

                            _obj[wordCodes[i]]++;//如果这个属性有值，就让这个属性的值自增1
                            repeatCode.push(wordCodes[i])
                        } else {
                            _obj[wordCodes[i]] = 1;//因为_obj[_str3[i]]初始没有值,所以在这里把这个属性的值初始为1,
                            //代表这个属性在字符串中已经出现了一次
                        }
                    }
                }
                repeatCode = [...new Set(repeatCode)]


                const tableTitle = header.map(item => {
                    return {
                        title: item,
                        key: item,
                        minWidth: 220,
                        render: (h, params) => {
                            let itemObj = params.row
                            let flag = 1
                            let colorObj = { '1': '#5a516e', '2': '#ed4014' }
                            let reg = /^\w+$/;

                            if (itemObj['wordCode'] && !reg.test(itemObj['wordCode'])) {
                                flag = 2;
                                this.allowUpload = false
                            }

                            repeatCode.map(item => {
                                if (itemObj['wordCode'] == item) {
                                    flag = 2;
                                    this.allowUpload = false
                                }
                            })

                            filedArr.map(sitem => {
                                if (!itemObj[sitem]) {
                                    flag = 2;
                                    this.allowUpload = false
                                }
                            })
                            let style = {
                                color: colorObj[flag]
                            }
                            return h('div', { style }, params.row[item] || '')
                        }
                    }
                })




                this.tableData = results.map(item => {
                    item.addFlag = true
                    filedArr.map(sitem => {
                        if (!item[sitem]) {
                            item.addFlag = false
                        }
                    })

                    if (item.addFlag) {
                        this.totalCount += 1
                    }
                    item.cellClassName = {wordCode:''}
                   
                    return item
                })

                this.tableTitle = tableTitle
                console.log('results', this.tableData)
                this.disabled = false
                this.uploadLoading = false
                this.tableLoading = false
                this.showRemoveFile = true
                this.readExcel(file)
            }
        },
        readExcel(file) {
            // 表格导入
            const fileReader = new FileReader()
            fileReader.onload = ev => {
                try {
                    const data = ev.target.result
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    })
                    const wsname = workbook.SheetNames[0] // 取第一张表
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
                    this.jsonData = ws
                    this.content = JSON.stringify(ws)

                } catch (e) {
                    // console.log('e',e)
                    return false
                }
            }
            fileReader.readAsBinaryString(file)
        },
        openOrClose(value) {

            if (value === false) {
                this.resetForm();//重置表单

            }
        },
        async subData() {//提交表单
            // console.log(this.tableData)
            this.disabled = true


            let opreateArr = this.tableData
            // let opreateArr = []

            // this.tableData.map(item=>{
            //     if(item.addFlag){
            //         opreateArr.push({...item,whetherSync:this.whetherSync,pageId:this.pageId})
            //     }
            // })

            let refreshIndex = opreateArr.length - 1; // 刷新次数索引
            // 用forEach/map的方式刷新太快，无法通过延时知道那个接口失败了。现在改用for循环+async+await+Promise的方式进行设备刷新。

            for(let i=0;i<opreateArr.length;i++){

                let params = {
                    ...opreateArr[i], whetherSync: this.whetherSync, pageId: this.pageId 
                }
                delete params.cellClassName
                delete params.addFlag
             
                let refreshResultValue = await this.axios.post(this.config.urlArray.addOneWordCode, {...params });
                // console.log('refreshResultValue',refreshResultValue)
                if (refreshResultValue.data.code == 1) {
                    this.successCount += 1
                    // continue;
                } else {
                    let msgContent = refreshResultValue.data.message ? '词条' + opreateArr[i]['wordCode'] + '创建失败' + refreshResultValue.data.message : '词条' + opreateArr[i]['wordCode'] + '创建失败'
                    common.msg('error', msgContent, () => {
                        this.failCount += 1
                    })
                    this.tableData.map((sitem)=>{
                        if(opreateArr[i]['wordCode']==sitem.wordCode){
                            sitem.cellClassName = {wordCode:'table-info-err'}
                        }

                        return sitem
                    })

                }
                // console.log('index',index)

                // 判断是否全部设备刷新完成
                if (i == refreshIndex) {
                    common.msg('success', this.$t("productPage.mulLang.finish"), () => {
                        // console.log(1111111)
                        this.disabled = false
                        this.finish = true

                        if (this.successCount == this.totalCount) {
                            this.cancel()
                        }


                    })
                    return
                }

            }

            // opreateArr.map(async (item, index) => {
            //     let params = {
            //         ...item, whetherSync: this.whetherSync, pageId: this.pageId 
            //     }
            //     delete params.cellClassName
            //     delete params.addFlag
             
            //     let refreshResultValue = await this.axios.post(this.config.urlArray.addOneWordCode, {...params });
            //     // console.log('refreshResultValue',refreshResultValue)
            //     if (refreshResultValue.data.code == 1) {
            //         this.successCount += 1
            //         // continue;
            //     } else {
            //         let msgContent = refreshResultValue.data.message ? '词条' + item['wordCode'] + '创建失败' + refreshResultValue.data.message : '词条' + item['wordCode'] + '创建失败'
            //         common.msg('error', msgContent, () => {
            //             this.failCount += 1
            //         })

            //         this.tableData.map((sitem,sindex)=>{
            //             // console.log('sindex',sindex==index)
            //             if(index==sindex){
            //                 sitem.cellClassName = {wordCode:'table-info-err'}
            //             }

            //             return sitem
            //         })

            //     }
            //     // console.log('index',index)

            //     // 判断是否全部设备刷新完成
            //     if (index == refreshIndex) {
            //         common.msg('success', this.$t("productPage.mulLang.finish"), () => {
            //             // console.log(1111111)
            //             this.disabled = false
            //             this.finish = true

            //             if (this.successCount == this.totalCount) {
            //                 this.cancel()
            //             }


            //         })
            //         return
            //     }

            // })

        },
      
        cancel() {//对话框关闭
            this.resetForm();//重置表单
            this.fn()
            this.$emit('update:showModel', false);
        },
        resetForm() {//重置表单
            // this.$refs.formData.resetFields();//重置表单
            this.content = "";
            this.file = {};
            this.tableData = [];
            this.jsonData = [];
            this.tableTitle = [];
            this.uploadLoading = false;
            this.tableLoading = false;
            this.showRemoveFile = false;
            this.showProgress = false;
            this.progressPercent = 0
            this.modalTip = false;
            this.totalCount = 0;
            this.successCount = 0;
            this.failCount = 0;
            this.disabled = false;//恢复提交按钮为激活状态
            this.finish = false;
            this.allowUpload = true;
            this.whetherSync = true;

        }
    }
}
</script>

<style>
.ivu-table .table-info-err{
        background-color: #ed4014;
}
</style>
<style lang='less' scoped>


/deep/ .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }

}

.changeBox {
    /deep/ .ivu-form-item-content {
        margin-left: 0 !important;
        text-align: center;

    }

}

</style>

